import { Model } from '@descomplica/dex-models';

export interface StudyPlanningChimeraContractInfo {
  contractDate: string;
  contractExpirationDate: string;
}

export class StudyPlanningChimeraContractModel extends Model {
  contractDate: Date;

  contractExpirationDate: Date;

  constructor(chimeraContract: StudyPlanningChimeraContractInfo, getters: any) {
    super(getters);

    this.contractDate = new Date(chimeraContract.contractDate);
    this.contractExpirationDate = new Date(chimeraContract.contractExpirationDate);
  }
}
